import { typeCreatorV2 } from '../../../redux/utils/common';

export const UPDATE_SETTINGS: string = typeCreatorV2(
  'SettingsAdditionalReducer',
  'UpdateSettings'
);

export const SET_SETTINGS: string = typeCreatorV2(
  'SettingsAdditionalReducer',
  'SetSettings'
);
